import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=1b393b96"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports